var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4004 3.90039H8.70055C9.47377 3.90039 10.1006 4.52721 10.1006 5.30042V11.6006C10.1006 12.3738 9.47377 13.0006 8.70055 13.0006H2.4004C1.62719 13.0006 1.00037 12.3738 1.00037 11.6006V5.30042C1.00037 4.52721 1.62719 3.90039 2.4004 3.90039Z",
    stroke: "#2B8FF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 10.1002H11.6C11.9713 10.1002 12.3274 9.95271 12.5899 9.69016C12.8525 9.4276 13 9.0715 13 8.70018V2.40003C13 2.02872 12.8525 1.67262 12.5899 1.41006C12.3274 1.1475 11.9713 1 11.6 1H5.29982C4.9285 1 4.5724 1.1475 4.30984 1.41006C4.04729 1.67262 3.89978 2.02872 3.89978 2.40003V3.10005",
    stroke: "#2B8FF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlue);
export default __webpack_public_path__ + "static/media/copyIcon-blue.59ea2826d11957cf3ff1f239fed84027.svg";
export { ForwardRef as ReactComponent };